import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { PlusIcon } from "@heroicons/react/20/solid";
import { useEditor } from "../../hooks/EditorProvider";
import classNames from "../../helpers/classNames";
const DraggableAddComponent = ({ draggableId, elementId }) => {
    const { setDragElementMenu, iframeMount, dragElementMenu } = useEditor();
    const handleClick = (e) => {
        setDragElementMenu({
            x: e.clientX,
            y: e.clientY + iframeMount.scrollTop,
            draggableId,
            elementId,
        });
    };
    return (_jsx(_Fragment, { children: _jsx("button", { onClick: handleClick, type: "button", className: classNames("focus:ring-app-500 relative flex h-[20px] w-[20px] items-center justify-center rounded-full border text-sm font-medium focus:z-10 focus:outline-none focus:ring-1", dragElementMenu?.draggableId === draggableId
                ? "bg-app-500 border-app-500 text-white"
                : "hover:bg-app-200 bg-white text-black"), children: _jsx(PlusIcon, { className: "h-3 w-3", "aria-hidden": "true" }) }) }));
};
export default DraggableAddComponent;
//# sourceMappingURL=DraggableAddComponent.js.map